function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54 90H7.51666C3.36533 90 0 93.3653 0 97.5167C0 101.668 3.36532 105.033 7.51666 105.033H39.2399V137.62C39.2399 141.696 42.5441 145 46.62 145C50.6958 145 54 141.696 54 137.62V90Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M90 91V137.483C90 141.635 93.3653 145 97.5167 145C101.668 145 105.033 141.635 105.033 137.483V105.76H137.62C141.696 105.76 145 102.456 145 98.38C145 94.3042 141.696 91 137.62 91H90Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M91 55L137.483 55C141.635 55 145 51.6347 145 47.4833C145 43.332 141.635 39.9667 137.483 39.9667H105.76L105.76 7.38004C105.76 3.30416 102.456 5.4784e-06 98.38 5.83472e-06C94.3041 6.19105e-06 91 3.30416 91 7.38004V55Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M56 54L56 7.51666C56 3.36533 52.6347 1.81461e-07 48.4833 0C44.332 -1.81461e-07 40.9667 3.36532 40.9667 7.51666V39.2399H8.38003C4.30415 39.2399 1 42.5441 0.999999 46.62C0.999999 50.6958 4.30415 54 8.38003 54L56 54Z"
});

function SvgExitFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullscreen);
export default __webpack_public_path__ + "static/media/exit_fullscreen.2998035d.svg";
export { ForwardRef as ReactComponent };